const links = [
    {
        label: 'Home',
        url: '/'
    },
    {
        label: 'Fertilidade',
        url: '/fertilidade'
    },
    {
        label: 'Gestação',
        url: '/gestacao'
    },
    {
        label: 'Pós Parto',
        url: '/pos-parto'
    },
    {
        label: 'Sobre mim',
        url: '/about'
    },
    {
        label: 'Blog',
        url: '/blog'
    },
    {
        label: 'Contato',
        url: '/contato'
    }
]

export default links;